import { JSX } from "react";

export const BrandingPdfItemSkeleton = (): JSX.Element => {
    return (
        <>
            {Array(3)
                .fill(0)
                .map((_, index) => (
                    <div className="c-branding-pdf-item" key={index}>
                        <div className="c-branding-pdf-item__image skeleton skeleton-no-border-radius"></div>
                        <div className="c-branding-pdf-item__title skeleton skeleton-no-border-radius"></div>
                    </div>
                ))}
        </>
    );
};
